import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'
import { fittersLocator } from './fitters-locator/reducers';
import { onWaiting, navMenu, bootstrap, contact } from './CommonReducers';
import { signUp } from './sign-up/reducers';
import { pages } from './pages/reducers';
import { profile } from './profile/reducers';
import { changePassword } from './change-password/reducers';
import { stance } from './stance/reducers';
import { myUsers } from './my-users/reducers';
import { gripsize } from './gripsize/reducers';

const app = combineReducers({
    routing: routerReducer,
    fittersLocator,
    onWaiting,
    signUp,
    navMenu,
    pages,
    profile,
    changePassword,
    stance,
    bootstrap,
    myUsers,
    contact,
    gripsize
})

export default app;


// WEBPACK FOOTER //
// ./src/Reducers.js